import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';

import {IonicModule} from '@ionic/angular';
import {TranslatePipe} from '@ngx-translate/core';

import {KnowledgeArticleDto, KnowledgeArticleStartDto} from '@server-models';
import {SharedAttachmentsComponent} from '@shared/components/attachments/shared-attachments.component';
import {SharedUserHtmlComponent} from '@shared/components/user-html/shared-user-html.component';
import {SharedKnowledgeService} from "@shared/components/knowledge/services/shared-knowledge.service";
import {lastValueFrom, take} from "rxjs";


@Component({
  selector: 'app-shared-knowledge-article-detail',
  templateUrl: './shared-knowledge-article-detail.component.html',
  styleUrls: ['./shared-knowledge-article-detail.component.scss'],
  standalone: true,
  imports: [IonicModule, TranslatePipe, SharedAttachmentsComponent, SharedUserHtmlComponent]
})
export class SharedKnowledgeArticleDetailComponent implements OnInit, OnChanges {
  private knowledgeService = inject(SharedKnowledgeService);


  @Input() article!: KnowledgeArticleStartDto | KnowledgeArticleDto;
  @Input() loadFullArticle: boolean = false;

  loading: boolean = false;

  async ngOnInit(): Promise<void> {
    await this._loadFullArticle();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['article']) {
      await this._loadFullArticle();
    }
  }

  private async _loadFullArticle(): Promise<void> {
    if (this.loadFullArticle && this.article.knowledgeArticleId) {
      this.loading = true;
      this.article = await lastValueFrom(this.knowledgeService.getArticle(this.article.knowledgeArticleId).pipe(take(1)));
      this.loading = false;
    }
  }

}
